import {AfterViewInit, ChangeDetectorRef, Component, ElementRef, Input, OnInit, Renderer2, ViewChild} from '@angular/core';
import {
  firstNestedSymbolControl,
  flatMap,
  hasGruppeTechnischeSteuerung,
  WertelisteElement,
  Wertemenge
} from '../../../models/uiArtefakt';
import {
  ErrorService,
  ErrorStateMatcherFailure,
  ErrorStateMatcherNoFailure,
  ISymbol,
  StringUtils,
  TranslationService,
  UiConfigService
} from '@lv1871/core';
import {NgForm, NgModel} from '@angular/forms';
import {ValidationService} from '../../../services/validation.service';
import {UiUpdateService} from '../../../services/ui-update.service';
import {WertemengenService} from '../../../services/wertemengen.service';
import {UIDarstellungsart} from '../../../models/uiDarstellungsart';
import {ErrorStateMatcher} from '@angular/material/core';
import {UIAusrichtung} from '../../../models/uiAusrichtung';
import {ShellConfigService} from '../../../services/shell-config.service';
import {EnumGruppeTechnischeSteuerung, hasAvvEinwilligung} from '../../../models/enumGruppeTechnischeSteuerung';
import {EventService} from '../../../services/event.service';
import {MeldungPipe} from '../../../pipes/meldung.pipe';
import {HttpClient} from '@angular/common/http';
import {switchMap, take, tap} from 'rxjs/operators';
import {UiControl} from '../../../models/uiControl';
import {UiModelService} from '../../../services/ui-model.service';

@Component({
    selector: 'lv-dropdown',
    templateUrl: './dropdown.component.html',
    styleUrls: ['./dropdown.component.scss'],
    providers: [WertemengenService, MeldungPipe],
    standalone: false
})
export class DropdownComponent implements OnInit, AfterViewInit {

  @ViewChild(NgForm, {static: true})
  private _ngForm;

  @ViewChild('lvdropdown', {static: true})
  private _dropdown: NgModel;

  public loadedOptions$;
  public value: WertelisteElement;
  public isDisabled: boolean = false;
  public stateMatcherFormInput: ErrorStateMatcher;
  public showUntruncatedError: boolean = false;
  public uiAusrichtung: UIAusrichtung;
  public nestedSymbol: ISymbol;
  public showInfotextCollapsable: boolean = false;

  private _uiArtefakt: Wertemenge;

  constructor(private _cd: ChangeDetectorRef, private _validationService: ValidationService,
              private _uiUpdateService: UiUpdateService, private _errorService: ErrorService,
              private _translationService: TranslationService, private _shellConfigService: ShellConfigService,
              private _wertemengenService: WertemengenService, private _eventService: EventService,
              private _meldungPipe: MeldungPipe, private _configService: UiConfigService, private _http: HttpClient,
              private _uiModelService: UiModelService,
              private _renderer: Renderer2, private _element: ElementRef) {

  }

  get uiArtefakt(): Wertemenge {
    return this._uiArtefakt;
  }

  @Input() set uiArtefakt(uiArtefakt: Wertemenge) {
    if (this._hasWertelisteChanged(uiArtefakt)) {
      if (!this.value) {
        this.loadedOptions$.next(uiArtefakt.Werteliste);
        this._uiArtefakt = uiArtefakt;
        return;
      }
      const isModelValueInNewWerteliste = this._wertelisteContainsWertEingabe(uiArtefakt);
      this.loadedOptions$.next(uiArtefakt.Werteliste);
      if (!isModelValueInNewWerteliste) {
        this._uiArtefakt = uiArtefakt;
        if (!!this.value) {
          this.value.WertEingabe = null;
          this.value.WertAnzeige = null;
        }
        this._uiArtefakt.WertEingabe = null;
        this._uiArtefakt.WertAnzeige = null;
        return;
      }
    }

    this._uiArtefakt = uiArtefakt;
    this.isDisabled = this._uiArtefakt?.Darstellungsart === UIDarstellungsart.DISABLED ||
        (this._uiArtefakt.Werteliste?.length === 1 && !!this._uiArtefakt.WertAnzeige && !!this._uiArtefakt.WertEingabe) ||
        !hasAvvEinwilligung(hasGruppeTechnischeSteuerung(
                this.uiArtefakt, EnumGruppeTechnischeSteuerung.AVVEINWILLIGUNG),
            this._eventService.avvEinwilligungImAntrag$.getValue(),
            this._eventService.vermittlerdatenFuerAvvGesetzt$.getValue());
    if (!!this._uiArtefakt.WertEingabe && !!this.value && this._uiArtefakt.WertEingabe !== this.value.WertEingabe) {
      this.value.WertEingabe = this._uiArtefakt.WertEingabe;
      this.value.WertAnzeige = this._uiArtefakt.WertAnzeige;
    }
  }

  public infotextCollapsableChange(event) {
    this.showInfotextCollapsable = event;
  }

  public ngOnInit(): void {
    this.loadedOptions$ = this._wertemengenService.filteredOptions$;
    this.uiAusrichtung = this._shellConfigService.getParameter().uiAusrichtung;
    this.nestedSymbol = firstNestedSymbolControl(this.uiArtefakt.UIArtefakt);
    if (this._uiArtefakt.WertEingabe !== null){
      this.value = {
        WertEingabe: this._uiArtefakt.WertEingabe,
        WertAnzeige: this._uiArtefakt.WertAnzeige
      } as WertelisteElement;
    }
    if ((this._uiArtefakt.FeldnameExtern === '/vnKollektiv' ||
        this._uiArtefakt.FeldnameExtern === '/traegerunternehmen') && this._uiArtefakt.Werteliste.length === 1) {
      this.value = this._uiArtefakt.Werteliste[0];
      this.setAntwortDropdown(this.value);
    }
    this._validationService.registerForm(this._uiArtefakt, this._ngForm);
    this._wertemengenService.filterWertemenge(this.uiArtefakt, '', [], 1000);
  }

  public ngAfterViewInit() {
    this._cd.detectChanges();
    this._renderer.setAttribute(this._element.nativeElement, 'cypress-uuid', this.uiArtefakt.IdentifikatorUuid);
    if(!!this.uiArtefakt.ReferenzIdentifikator) {
      this._renderer.setAttribute(this._element.nativeElement, 'cypress-refId', this.uiArtefakt.ReferenzIdentifikator);
    }
  }

  public setAntwortDropdown(value: WertelisteElement) {
    this._uiArtefakt.WertEingabe = value.WertEingabe;
    this._uiArtefakt.WertAnzeige = value.WertAnzeige;
    if (this._uiArtefakt.FeldnameExtern === '/vnKollektiv') {
      this._eventService.uiControls$.pipe(
          take(1),
          switchMap(control => {
            const vnJuristischePerson = flatMap(control.uiVorgang.UIArtefakt).filter(uiArtefakt =>
                uiArtefakt.UIArtefakttyp === 'UIVorgangReferenz' && uiArtefakt['UIVorgangID'] === 'VersicherungsnehmerJuristischePerson')[0];
            return this._http.post<UiControl>(
                this._configService.getAntragserfassungUrl() + '/api/produkt/kundenupdate/' + vnJuristischePerson.Identifikator + '/' + value.WertEingabe, control);
          }),
          tap(control => {
            this._eventService.uiControls$.next(control);
            this._eventService.uiControlsNewst$.next(control);
            this._uiModelService.requestUiControl(control).subscribe();
          })
      ).subscribe();
    } else if (this._uiArtefakt.FeldnameExtern === '/traegerunternehmen') {
      this._eventService.uiControls$.pipe(
          take(1),
          switchMap(control => {
            const vnJuristischePerson = flatMap(control.uiVorgang.UIArtefakt).filter(uiArtefakt =>
                uiArtefakt.UIArtefakttyp === 'UIVorgangReferenz' && uiArtefakt['UIVorgangID'] === 'Traegerunternehmen')[0];
            return this._http.post<UiControl>(
                this._configService.getAntragserfassungUrl() + '/api/produkt/kundenupdate/' + vnJuristischePerson.Identifikator + '/' + value.WertEingabe, control);
          }),
          tap(control => {
            this._eventService.uiControls$.next(control);
            this._eventService.uiControlsNewst$.next(control);
            this._uiModelService.requestUiControl(control).subscribe();
          })
      ).subscribe();
    } else if (this._uiArtefakt.FeldnameExtern === '/traegerunternehmen') {
      this._eventService.uiControls$.pipe(
          take(1),
          switchMap(control => {
            const vnJuristischePerson = flatMap(control.uiVorgang.UIArtefakt).filter(uiArtefakt =>
                uiArtefakt.UIArtefakttyp === 'UIVorgangReferenz' && uiArtefakt['UIVorgangID'] === 'Traegerunternehmen')[0];
            return this._http.post<UiControl>(
                this._configService.getAntragserfassungUrl() + '/api/produkt/kundenupdate/' + vnJuristischePerson.Identifikator + '/' + value.WertEingabe, control);
          }),
          tap(control => {
            this._eventService.uiControls$.next(control);
            this._eventService.uiControlsNewst$.next(control);
            this._uiModelService.requestUiControl(control).subscribe();
          })
      ).subscribe();
    } else if (this._uiArtefakt.FeldnameExtern === '/traegerunternehmen') {
      this._eventService.uiControls$.pipe(
          take(1),
          switchMap(control => {
            const vnJuristischePerson = flatMap(control.uiVorgang.UIArtefakt).filter(uiArtefakt =>
                uiArtefakt.UIArtefakttyp === 'UIVorgangReferenz' && uiArtefakt['UIVorgangID'] === 'Traegerunternehmen')[0];
            return this._http.post<UiControl>(
                this._configService.getAntragserfassungUrl() + '/api/produkt/kundenupdate/' + vnJuristischePerson.Identifikator + '/' + value.WertEingabe, control);
          }),
          tap(control => {
            this._eventService.uiControls$.next(control);
            this._eventService.uiControlsNewst$.next(control);
            this._uiModelService.requestUiControl(control).subscribe();
          })
      ).subscribe();
    } else {
      this._uiUpdateService.valueChangedSubject$.next(this._uiArtefakt);
    }
  }

  public compareObjects(elem1: WertelisteElement, elem2: WertelisteElement): boolean {
    return StringUtils.isNotNull(elem1) && StringUtils.isNotNull(elem2) && elem1.WertEingabe === elem2.WertEingabe;
  }

  public getError(): string {
    this.stateMatcherFormInput = new ErrorStateMatcherFailure();
    if (!!this.uiArtefakt.WertEingabe && !this._wertelisteContainsWertEingabe(this.uiArtefakt) ||
        this.uiArtefakt.PflichtfeldJN && this._dropdown?.touched && !this.uiArtefakt.WertEingabe) {
      const requiredError = this._translationService.translate('ERRORS.REQUIRED');
      return !!this.uiArtefakt.FehlertextPflichtfeld ? this.uiArtefakt.FehlertextPflichtfeld : requiredError;
    }
    if (this.uiArtefakt.UIMeldung?.length && this._dropdown?.touched) {
      return this._meldungPipe.getMostImportantMeldungstext(this.uiArtefakt.UIMeldung);
    }
    this.stateMatcherFormInput = new ErrorStateMatcherNoFailure();
    this.showUntruncatedError = false;
    return null;
  }

  public onErrorClick() {
    this.showUntruncatedError = !this.showUntruncatedError;
  }

  onBlur() {
    if (!!this._uiArtefakt.ReferenzIdentifikator) {
      this._eventService.refIdentTouchedOrDirty$.next(this._uiArtefakt.ReferenzIdentifikator);
    }
  }

  private _hasWertelisteChanged(uiArtefakt: Wertemenge): boolean {
    return !!this._uiArtefakt && !!uiArtefakt && JSON.stringify(this._uiArtefakt?.Werteliste) !== JSON.stringify(uiArtefakt?.Werteliste);
  }

  private _wertelisteContainsWertEingabe(uiArtefakt: Wertemenge): boolean {
    if (!uiArtefakt.Werteliste?.length) {
      return true;
    }
    const isInWerteliste = !!uiArtefakt.Werteliste.filter(elem =>
        elem.WertEingabe === this.value?.WertEingabe).length;
    if (!isInWerteliste && !!this._ngForm.controls[this._uiArtefakt.Identifikator]) {
      this._ngForm.controls[this._uiArtefakt.Identifikator].markAsDirty();
      this._ngForm.controls[this._uiArtefakt.Identifikator].markAsTouched();
    }
    return isInWerteliste;
  }
}
